import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tag } from '../Tag';
import { WarnIcon } from '../icons/WarnIcon';
import { Chevron } from '../icons/Chevron';
import { VisitBody } from './VisitBody';

export const VisitCard = ({ visit, onToggle }) => {
    const { t } = useTranslation('reportPage');
    const label = visit.n != null ? `#${visit.n}` : visit.date;

    return (
        <article
            className={`visit jr-card${visit.isOpen ? ' open' : ''}${visit.flag ? ' flagged' : ''}`}
            id={`v${visit.key}`}
        >
            <div className="vhead">
                <span className="v-date">{visit.date}</span>
                {visit.n != null && <span className="v-n">#{visit.n}</span>}
                {visit.tags.length > 0 && (
                    <div className="v-tags">
                        {visit.tags.map(tag => (
                            <Tag tone={tag.style} key={tag.label}>
                                {tag.label}
                            </Tag>
                        ))}
                    </div>
                )}
                <span className="spacer" />
                {visit.parts.length > 0 && !visit.isOpen && <span className="v-parts">{visit.partsLabel}</span>}
                {visit.flag && (
                    <span className="v-flag">
                        <WarnIcon size={16} strokeWidth={16} />
                        {t('history.redFlagTag')}
                    </span>
                )}
                {visit.hasDetail && (
                    <button
                        type="button"
                        className="iconbtn noprint"
                        aria-expanded={visit.isOpen}
                        aria-label={
                            visit.isOpen
                                ? t('journey.collapse', { visit: label })
                                : t('journey.expand', { visit: label })
                        }
                        onClick={() => onToggle(visit.key, !visit.isOpen)}
                    >
                        <Chevron open={visit.isOpen} />
                    </button>
                )}
                {(!visit.isOpen || !visit.hasDetail || visit.group) && (
                    <span className="v-sum src" style={{ flexBasis: '100%' }}>
                        {visit.summary}
                    </span>
                )}
                {visit.dealer && (
                    <span className="v-dealer src" style={{ flexBasis: '100%' }}>
                        {visit.dealer}
                    </span>
                )}
            </div>
            {visit.hasDetail && <VisitBody visit={visit} />}
        </article>
    );
};
